// extracted by mini-css-extract-plugin
export default {"hyperlinkPopover_target":"HyperlinkPopover_hyperlinkPopover_target__edztj","hyperlinkPopover_dropdown":"HyperlinkPopover_hyperlinkPopover_dropdown__00d0+"};